import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import type { TLeasedPropertyInfo } from '@/pages/LeasedPropertyInfo/types/leased-property.types';

interface ILeasedPropertyInfoState {
  propertyInfo: TLeasedPropertyInfo | null;
  isEditing: boolean;
}

const initialState: ILeasedPropertyInfoState = {
  propertyInfo: null,
  isEditing: false
};

const leasedPropertyInfoSlice = createSlice({
  name: 'leasedPropertyInfo',
  initialState,
  reducers: {
    setPropertyInfo: (
      state,
      action: PayloadAction<TLeasedPropertyInfo | null>
    ) => {
      state.propertyInfo = action.payload;
    },
    setIsEditing: (state, action: PayloadAction<boolean>) => {
      state.isEditing = action.payload;
    }
  }
});

export const { setPropertyInfo, setIsEditing } =
  leasedPropertyInfoSlice.actions;

export default leasedPropertyInfoSlice;
